export default __webpack_public_path__ + "4aa7791d7bb9634b04a661d3ded79e95.svg";